<div class="page-container container" style="overflow-y: auto;padding-top:50px  ">
  <mat-card>
     <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <div *ngIf="!loading">

      <p *ngIf="firstName"  ><b>Name:</b> {{ firstName}} {{lastName}}</p>
      <p *ngIf="email"><b>Email:</b> {{ email}} </p>
      <p *ngIf="phone"><b>Phone:</b> {{phone}}</p>
      <p *ngIf="company"><b>Company:</b> {{company}}</p>
      <p *ngIf="brokerId"><b>Broker ID:</b> {{brokerId}}</p>
      <p *ngIf="salesPerson"><b>Sales Person:</b> {{salesPerson}}</p>
      <br><br><br>
      <span (click)="logout()" class="sign-out">Sign Out</span>
    </div>

  </mat-card>


</div>

